"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIEnginesDictInstance = exports.AgentsIDsToRelatedWorkmode = exports.AgentsIDsToRelatedEventType = exports.aiIntanciator = exports.EnginesIDsToAIAIType = exports.AITypeToAIEnginesIDs = exports.AIAgentsIDs = exports.AIEnginesIDs = void 0;
const bandit_manchot_1 = require("@evidenceb/bandit-manchot");
const adaptive_tests_1 = require("@evidenceb/adaptive-tests");
const ai_handler_1 = require("@evidenceb/ai-handler");
const athena_revision_1 = require("@evidenceb/athena-revision");
/**
 *
 */
var AIEnginesIDs;
(function (AIEnginesIDs) {
    AIEnginesIDs["zpdes"] = "zpdes";
    AIEnginesIDs["adaptiveTest"] = "adaptiveTest";
    AIEnginesIDs["revisionAlg"] = "revisionAlg";
    AIEnginesIDs["cnedAdaptiveTest"] = "cnedAdaptiveTest";
})(AIEnginesIDs = exports.AIEnginesIDs || (exports.AIEnginesIDs = {}));
var AIAgentsIDs;
(function (AIAgentsIDs) {
    AIAgentsIDs["studentActivityMonitorAgent"] = "studentActivityMonitorAgent";
    AIAgentsIDs["messageManegementAgent"] = "messageManegementAgent";
    AIAgentsIDs["eventButler"] = "eventButler";
})(AIAgentsIDs = exports.AIAgentsIDs || (exports.AIAgentsIDs = {}));
/**
 *
 */
// [TODO] Ne plus utiliser AITypes nulle part
exports.AITypeToAIEnginesIDs = {
    [ai_handler_1.AIType.BanditManchot]: AIEnginesIDs.zpdes,
    [ai_handler_1.AIType.AdaptiveTest]: AIEnginesIDs.adaptiveTest,
    [ai_handler_1.AIType.RevisionManager]: AIEnginesIDs.revisionAlg,
    [ai_handler_1.AIType.CNEDAdaptiveTest]: AIEnginesIDs.cnedAdaptiveTest,
};
/**
 *
 */
exports.EnginesIDsToAIAIType = {
    [AIEnginesIDs.zpdes]: ai_handler_1.AIType.BanditManchot,
    [AIEnginesIDs.adaptiveTest]: ai_handler_1.AIType.AdaptiveTest,
    [AIEnginesIDs.revisionAlg]: ai_handler_1.AIType.RevisionManager,
    [AIEnginesIDs.cnedAdaptiveTest]: ai_handler_1.AIType.CNEDAdaptiveTest,
};
/**
 *
 */
exports.aiIntanciator = {
    [AIEnginesIDs.zpdes]: bandit_manchot_1.ZpdesHssbgGraph,
    [AIEnginesIDs.adaptiveTest]: adaptive_tests_1.AdaptiveTest,
    [AIEnginesIDs.revisionAlg]: athena_revision_1.RevisionAlg,
    [AIEnginesIDs.cnedAdaptiveTest]: adaptive_tests_1.CNED_AdaptiveTest,
};
/**
 *
 */
exports.AgentsIDsToRelatedEventType = {
    [AIAgentsIDs.studentActivityMonitorAgent]: ["ResultExerciseEvent"],
    [AIAgentsIDs.messageManegementAgent]: ["AIScoreVariationEvent", "AIActivationEvent", "AIDeactivationEvent", "ResultExerciseEvent"],
    [AIAgentsIDs.eventButler]: ["ResultExerciseEvent", "AICurriculumFinishedEvent", "AIShowMessageEvent"],
};
exports.AgentsIDsToRelatedWorkmode = {
    [AIAgentsIDs.studentActivityMonitorAgent]: ["solo-ai"],
    [AIAgentsIDs.messageManegementAgent]: ["solo-ai"],
    [AIAgentsIDs.eventButler]: ["solo-ai", "duo", "standalone-adaptive-test", "revision"],
};
/**
 *
 */
exports.AIEnginesDictInstance = {
    [AIEnginesIDs.zpdes]: bandit_manchot_1.ZpdesHssbgGraph,
    [AIEnginesIDs.adaptiveTest]: adaptive_tests_1.AdaptiveTest,
    [AIEnginesIDs.revisionAlg]: athena_revision_1.RevisionAlg,
    [AIEnginesIDs.cnedAdaptiveTest]: adaptive_tests_1.CNED_AdaptiveTest,
};
/* Test to build dictionnaries of AiEngine a la volée


export enum AIEnginesIDs {
    zpdes = AIType.BanditManchot,
    adaptiveTest = AIType.AdaptiveTest,
    cnedAptiveTest = AIType.CNEDAdaptiveTest,
    revisionAlg = AIType.RevisionManager
}

// export const StringIdKeyOfAIEnginesDict : {[key: string] : keyof AIEnginesDict} = {
//     "zpdes": zpdes,
//     "adaptiveTest": adaptiveTest,
//     "revisionAlg": revisionAlg
// }

// export interface AIEnginesDictType{
//     [algId: string]: AIEngine
// }


// export interface TypeOfAIEnginesDict{
//     [algId: string]: typeof ZpdesHssbgGraph | typeof AdaptiveTest | typeof RevisionAlg
// }




// export const AIEnginesDictConst : {[key in keyof AIEnginesDict]: new (config: any) => AIEnginesDict[key]} = {
//     "zpdes" : ZpdesHssbgGraph,
//     "adaptiveTest" : AdaptiveTest,
//     "revisionAlg" : RevisionAlg
// }
*/
